/**
 * @file index.jsx
 * @author Rishikesh
 * @date 2024-09-11
 * @description Manages the leads informations and listings
 */
import React, { useState } from "react";
import { useFetchData } from "../../components/hooks/useFetchData";
import { Box } from "@mui/material";
import { CandidatesList } from "./CandidatesList";

const CandidatesPage = () => {
  const [minLoading, setMinLoading] = useState(true);
  const [candidateList, setCandidateList] = useState([]);

  const { fetchData, loading } = useFetchData();

  const getAllCandidates = async () => {
    const result = await fetchData("getcandidates?type=candidate");
    if (result?.code === 200) {
      setCandidateList(result.data);
    }
  };

  const searchByPhone = async (phone) => {
    const body = { phone: phone };
    const result = await fetchData("searchbyphone", {
      method: "post",
      body: body,
    });
    if (result?.code === 200) {
      setCandidateList(result.data);
    } else {
      setCandidateList([]);
    }
  };

  React.useEffect(() => {
    getAllCandidates();
    const minLoadingTimer = setTimeout(() => {
      setMinLoading(false);
    }, 1500);

    return () => clearTimeout(minLoadingTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isLoading = minLoading || loading["getcandidates"];

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        height="100%"
        overflow="hidden"
      >
        <CandidatesList
          leads={candidateList}
          isLoading={isLoading}
          searchByPhone={searchByPhone}
        />
      </Box>
    </>
  );
};

export default CandidatesPage;
